export const FETCH_SECTION_REQUEST = "FETCH_SECTION_REQUEST";
export const FETCH_SECTION_SUCCESS = "FETCH_SECTION_SUCCESS";
export const FETCH_SECTION_FAILURE = "FETCH_SECTION_FAILURE";

export const FETCH_SECTION_SECTIONS_REQUEST = "FETCH_SECTION_SECTIONS_REQUEST";
export const FETCH_SECTION_SECTIONS_SUCCESS = "FETCH_SECTION_SECTIONS_SUCCESS";
export const FETCH_SECTION_SECTIONS_FAILURE = "FETCH_SECTION_SECTIONS_FAILURE";

export const FETCH_SECTION_ARTICLES_REQUEST = "FETCH_SECTION_ARTICLES_REQUEST";
export const FETCH_SECTION_ARTICLES_SUCCESS = "FETCH_SECTION_ARTICLES_SUCCESS";
export const FETCH_SECTION_ARTICLES_FAILURE = "FETCH_SECTION_ARTICLES_FAILURE";

export const MOVE_ARTICLE_TO_SECTION_REQUEST =
  "MOVE_ARTICLE_TO_SECTION_REQUEST";
export const MOVE_ARTICLE_TO_SECTION_SUCCESS =
  "MOVE_ARTICLE_TO_SECTION_SUCCESS";
export const MOVE_ARTICLE_TO_SECTION_FAILURE =
  "MOVE_ARTICLE_TO_SECTION_FAILURE";

export const POSITION_ARTICLE_REQUEST = "POSITION_ARTICLE_REQUEST";
export const POSITION_ARTICLE_SUCCESS = "POSITION_ARTICLE_SUCCESS";
export const POSITION_ARTICLE_FAILURE = "POSITION_ARTICLE_FAILURE";

export const POSITION_SECTION_REQUEST = "POSITION_SECTION_REQUEST";
export const POSITION_SECTION_SUCCESS = "POSITION_SECTION_SUCCESS";
export const POSITION_SECTION_FAILURE = "POSITION_SECTION_FAILURE";

export const MOVE_SECTION_TO_SECTION_REQUEST =
  "MOVE_SECTION_TO_SECTION_REQUEST";
export const MOVE_SECTION_TO_SECTION_SUCCESS =
  "MOVE_SECTION_TO_SECTION_SUCCESS";
export const MOVE_SECTION_TO_SECTION_FAILURE =
  "MOVE_SECTION_TO_SECTION_FAILURE";

export const MOVE_SECTION_TO_CATEGORY_REQUEST =
  "MOVE_SECTION_TO_CATEGORY_REQUEST";
export const MOVE_SECTION_TO_CATEGORY_SUCCESS =
  "MOVE_SECTION_TO_CATEGORY_SUCCESS";
export const MOVE_SECTION_TO_CATEGORY_FAILURE =
  "MOVE_SECTION_TO_CATEGORY_FAILURE";

export const MOVE_SECTION_TO_TOP_REQUEST = "MOVE_SECTION_TO_TOP_REQUEST";
export const MOVE_SECTION_TO_TOP_SUCCESS = "MOVE_SECTION_TO_TOP_SUCCESS";
export const MOVE_SECTION_TO_TOP_FAILURE = "MOVE_SECTION_TO_TOP_FAILURE";

export const MOVE_ARTICLE_TO_TOP_REQUEST = "MOVE_ARTICLE_TO_TOP_REQUEST";
export const MOVE_ARTICLE_TO_TOP_SUCCESS = "MOVE_ARTICLE_TO_TOP_SUCCESS";
export const MOVE_ARTICLE_TO_TOP_FAILURE = "MOVE_ARTICLE_TO_TOP_FAILURE";



// WEBPACK FOOTER //
// ./src/actions/section/types.js